module.exports = __webpack_public_path__ + "img/Number=98.eacc03ab.png";